export { default } from "./ShareModalView";
export type { ShareModalViewProps } from "./ShareModalView";
